import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "roblex-modal-overlay",
    templateUrl: "./modal-overlay.component.html",
    styleUrls: ["./modal-overlay.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class ModalOverlayComponent {
    constructor() {}
}
